<template>
  <div class="tabs tw-bg-[#ffffff] tw-max-w-[680px] tw-full-w">
    <div
      class="tab-header tw-flex tw-flex-wrap tw-px-[20px] sm:tw-px-[40px] tw-border-b-[#EFF0F1] tw-border-solid tw-border-[0] tw-border-b-[1px]"
    >
      <div
        v-for="(tab, index) in tabs"
        :key="index"
        class="tab tw-font-Poppins tw-text-[12px] tw-leading-[130%] tw-font-[500] tw-py-[20px] tw-cursor-pointer tw-text-center"
        :class="{
          selectedTab: selectedTab === index,
          unselectedTab: selectedTab !== index,
        }"
        @click="selectTab(tab, index)"
      >
        <span>{{ tab.title }}</span>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref } from "vue";
import { ISwitchTabs } from "@/interfaces/assessments/ISwitchTabs";
// eslint-disable-next-line no-unused-vars
const props = defineProps({
  /** Tabs Switch */
  tabs: {
    type: Array as () => ISwitchTabs[],
    required: true,
  },

  defaultTab: {
    type: Number,
    default: 0,
    required: false,
  },
});
const emit = defineEmits(["update:tab"]);

const selectedTab = ref(props.defaultTab);

const selectTab = (tab: ISwitchTabs, index) => {
  emit("update:tab", tab.id);
  selectedTab.value = index;
};
</script>

<style scoped lang="scss">
.tab-header {
  gap: 6px 30px;
  .tab {
    color: #231f20;
    border-bottom: 3px solid transparent;
    &.selectedTab {
      border-bottom-color: #387dff;
      color: #387dff;
    }
  }
}
.tabs {
  margin: 0 auto;
}
</style>
